import "./styles/Trends.css"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import {
  fetchStreamsDaily,
  fetchStreamsCountry,
  fetchStreamsDemographic,
  fetchTrendTopTracks,
  fetchStreamsTrackMonths,
  fetchArtistTrendEconomyData
} from "../../../actions/trendsActions"
import { Artist, ArtistTrendEconomy, Track, TrendFilter, TrendsProps, User } from "../../../types"
import { useNavigate } from "react-router-dom"
import {
  KButton,
  KDropdown,
  KInput,
  KLogo,
  KSelectRangeDate,
  KSpan,
  KTitleSpan,
  KTooltip
} from "kahuna-base-react-components"
import { getCountryCodeMap, lang } from "../../../constants/languages"
import Loading from "../../ui/Loading"
//@ts-ignore
import SparkleIcon from "../../../assets/admin_icons/music-note-sparkle.svg"
//@ts-ignore
import WorldIcon from "../../../assets/start_your_journey_icons/world-light.svg"
//@ts-ignore
import DemographicIcon from "../../../assets/start_your_journey_icons/demographic.png"
//@ts-ignore
import BarChartIcon from "../../../assets/start_your_journey_icons/bar-chart-square.svg"
//@ts-ignore
import MoneyIcon from "../../../assets/admin_icons/money-cash-grey.svg"
//@ts-ignore
import EarthIcon from "../../../assets/country-icons/earth.svg"
import StreamsDaily from "./streams-daily/StreamsDaily"
import StreamsCountry from "./streams-country/StreamsCountry"
import StreamsDemographic from "./streams-demographic/StreamsDemographic"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { toast } from "react-toastify"
import { handleAuthorizedRequest, users } from "../../../apis"
import {
  ADMIN_PERMISSIONS,
  ANALYSIS_TAB_OPTIONS,
  countryIcons,
  defaultEndDate,
  defaultStartDate,
  errorFilledToastOptions,
  platformIcons,
  successFilledToastOptions,
  TREND_TRACK_EVENT_TYPE,
  trendsIcons
} from "../../../constants"
import { capitalize, checkAdminPermission } from "../../../utility"
// @ts-ignore
import SpotifyLogo from "../../../assets/release-platform-icons/SpotifyLogo.png"
import StreamsTopTracks from "./streams-top-tracks/StreamsTopTracks"
import { countryMapEn } from "../../../constants/languages/countryMap/en"
import StreamsTrackMonths from "./streams-track-months/StreamsTrackMonths"
import RoyaltyThreeMonths from "./royalty-three-months/RoyaltyThreeMonths"
import { eventTypeOptions } from "../analysis-new/artist-overview/ArtistOverview"
import { socialTypeOptions } from "../analysis-new/audience-and-discovery/AudienceAndDiscovery"

const MILISECONDS_MONTH = 2678400000

enum TabOptions {
  STREAMS_DAILY,
  STREAMS_COUNTRY,
  STREAMS_DEMOGRAPHIC,
  STREAMS_TOP_TRACKS,
  STREAMS_TRACK_MONTHS,
  ROYALTY_THREE_MONTHS
}

export enum ChartIndex {
  OVERVIEW_BAR_CHART_TRACK = 1,
  OVERVIEW_PIE_CHART_PLATFORM = 2,
  OVERVIEW_BAR_CHART_PLATFORM = 3,
  OVERVIEW_LINE_CHART_TRACK = 4,
  OVERVIEW_LINE_CHART_PLATFORM = 5,
  COUNTRY_PIE_CHART = 6,
  COUNTRY_LINE_CHART = 7,
  COUNTRY_BAR_CHART = 8,
  DEMOGRAPHIC_PIE_CHART_AGE = 9,
  DEMOGRAPHIC_LINE_CHART_AGE = 10,
  DEMOGRAPHIC_PIE_CHART_SEX = 11,
  DEMOGRAPHIC_LINE_CHART_SEX = 12
}

export const EnlargeIcon = ({ setIndex, chartIndex }: { setIndex: (index: number) => void; chartIndex: number }) => {
  return (
    <div
      onClick={() => {
        setIndex(chartIndex)
      }}
      className="flex items-center cursor-pointer justify-center p-1 rounded-[4px] hover:bg-[#F7F7F7] absolute right-2 top-2"
    >
      <img src={"/enlarge.svg"} className="w-4 h-4" />
    </div>
  )
}

const Trends = ({
  streamsDaily,
  fetchStreamsDaily,
  streamsCountry,
  fetchStreamsCountry,
  streamsDemographic,
  fetchStreamsDemographic,
  trendTopTracks,
  fetchTrendTopTracks,
  fetchStreamsTrackMonths,
  artistTrendEconomyData,
  fetchArtistTrendEconomyData,
  options,
  isAdmin,
  user,
  externalTab,
  hideSideBarAndTitle,
  commonDateValues
}: TrendsProps) => {
  const [selectedTab, setSelectedTab] = useState<TabOptions | undefined>(isAdmin ? undefined : TabOptions.STREAMS_DAILY)
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const [filter, setFilter] = useState<TrendFilter>({
    dateValues: commonDateValues ?? [defaultStartDate, defaultEndDate],
    isrcList: [],
    countryList: [],
    ageGroupList: [],
    sexList: [],
    platformList: [],
    artistList: [],
    eventType: TREND_TRACK_EVENT_TYPE.DSP,
    isAdmin
  })
  const [platformOptions, setPlatformOptions] = useState<KSelectOption[]>([])
  const [selectedPlatforms, setSelectedPlatforms] = useState<KSelectOption[]>([])
  const [songOptions, setSongOptions] = useState<KSelectOption[]>([])
  const [artistOptions, setArtistOptions] = useState<KSelectOption[]>([])
  const [countryOptions, setCountryOptions] = useState<KSelectOption[]>([])
  const [sexOptions, setSexOptions] = useState<KSelectOption[]>([])
  const [ageGroupOptions, setAgeGroupOptions] = useState<KSelectOption[]>([])
  const [selectedUsers, setSelectedUsers] = useState<KSelectOption[]>([])
  const [loading, setLoading] = useState(false)
  const [fetchOptions, setFetchOptions] = useState(true)
  const [userOptions, setUserOptions] = useState<KSelectOption[]>([])
  const [userTimeoutId, setUserTimeoutId] = useState<NodeJS.Timeout>()
  const [offset, setOffset] = useState<number>(0)
  const [limit, setLimit] = useState<number>(20)
  const [selectedRoyaltyType, setSelectedRoyaltyType] = useState<KSelectOption>()
  const [selectedResults, setSelectedResults] = useState<ArtistTrendEconomy[]>([])
  const [hasNext, setHasNext] = useState<boolean>(false)
  const [fullScreenChartIndex, setFullScreenChartIndex] = useState<number | undefined>(undefined)
  const [selectedSocialType, setSelectedSocialType] = useState<string>("social_consumption")
  const twoDaysAgo = new Date()
  twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)
  const formattedDate = twoDaysAgo.toISOString().slice(0, 10).replace(/-/g, "") // "YYYYMMDD"
  const [date, setDate] = useState(formattedDate)
  const [normalizedEvent, setNormalizedEvent] = useState<
    "dsp" | "social_consumption" | "social_production" | "download"
  >("dsp")
  useEffect(() => {
    let event_type = "dsp"
    if (filter.eventType === "social") event_type = selectedSocialType
    else if (filter.eventType === "download") event_type = "download"
    setNormalizedEvent(event_type as typeof normalizedEvent)
  }, [filter.eventType, selectedSocialType])

  const navigate = useNavigate()

  const useTimeout = (timeoutInMs: number) => {
    setTimeout(() => {
      setLoading(false)
    }, timeoutInMs)
  }

  useEffect(() => {
    if (artistTrendEconomyData.results.length === limit) {
      setHasNext(true)
    } else {
      setHasNext(false)
    }

    setSelectedResults([...selectedResults, ...artistTrendEconomyData.results])
  }, [artistTrendEconomyData.results])

  const isInitialMount = useRef(true)
  useEffect(() => {
    if (isInitialMount.current && externalTab) {
      isInitialMount.current = false
      return
    }

    if (isAdmin && selectedTab === TabOptions.STREAMS_TOP_TRACKS) {
      setLoading(true)
      fetchTrendTopTracks(date, false, filter).then(() => {
        useTimeout(200)
      })
      return
    }

    if (isAdmin && selectedTab === TabOptions.STREAMS_TRACK_MONTHS) {
      fetchStreamsTrackMonths(filter, offset, limit, selectedRoyaltyType).then(() => {
        useTimeout(100)
      })
      return
    }

    if (isAdmin && selectedTab === TabOptions.ROYALTY_THREE_MONTHS) {
      fetchArtistTrendEconomyData(filter, offset, limit, selectedRoyaltyType).then(() => {
        useTimeout(100)
      })
      return
    }

    setLoading(true)
    if (selectedTab === TabOptions.STREAMS_DAILY) {
      fetchStreamsDaily(filter, fetchOptions).then(() => useTimeout(200))
    } else if (selectedTab === TabOptions.STREAMS_COUNTRY) {
      fetchStreamsCountry(filter, fetchOptions).then(() => useTimeout(200))
    } else if (selectedTab === TabOptions.STREAMS_DEMOGRAPHIC) {
      fetchStreamsDemographic(filter, fetchOptions).then(() => useTimeout(200))
    } else {
      setLoading(false)
    }
    setFetchOptions(false)
  }, [filter, offset, limit, selectedRoyaltyType])

  const processPlatformOptions = (platformOptions: string[]) => {
    return platformOptions.map((platform: string, index: number) => {
      return {
        label: capitalize(platform),
        value: index,
        value2: platform,
        icon: trendsIcons[platform],
        iconLabel: platform === "spotify" && SpotifyLogo
      }
    })
  }

  useEffect(() => {
    if (!options) {
      return
    }

    const songOptions = options.songOptions || []
    const platformOptions = options.platformOptions || []
    const countryOptions = options.countryOptions || []
    const artistOptions = options.artistOptions || []
    const sexOptions = options.sexOptions || []
    const ageGroupOptions = options.ageGroupOptions || []

    setSongOptions(
      songOptions.map((track: Track, index: number) => {
        return { label: track.title, value: index, value2: track.isrc }
      })
    )

    const platformOptionsProcessed = processPlatformOptions(platformOptions)

    if (filter.platformList.length === 0) {
      setSelectedPlatforms(platformOptionsProcessed)
    }

    setPlatformOptions(platformOptionsProcessed)

    setArtistOptions(
      artistOptions.map((artist: Artist, index: number) => {
        return { label: artist.name, value: artist.id || index, value2: artist.id?.toString() }
      })
    )

    const countryCodeMap = getCountryCodeMap()
    setCountryOptions(
      countryOptions.map((country: string, index: number) => {
        const label = countryCodeMap[country] ? `${countryCodeMap[country]} (${country})` : country
        const countryMap = countryMapEn
        const countryName = countryMap[country]
        const icon = countryIcons[countryName]
        return { label, value: index, value2: country, icon: icon ? icon : EarthIcon }
      })
    )

    setSexOptions(
      sexOptions.map((sex: string, index: number) => {
        return { label: sex, value: index, value2: sex }
      })
    )

    setAgeGroupOptions(
      ageGroupOptions.map((ageGroup: string, index: number) => {
        return { label: ageGroup, value: index, value2: ageGroup }
      })
    )
  }, [options])

  const renderTableTitle = () => {
    let title = lang.trends.streams_daily
    if (selectedTab === TabOptions.STREAMS_COUNTRY) title = lang.trends.streams_country
    else if (selectedTab === TabOptions.STREAMS_DEMOGRAPHIC) title = lang.trends.streams_demographic

    return (
      <div className="flex flex-row gap-2 !cursor-default items-center self-start">
        <KTooltip
          backgroundColor="#000"
          padding="0px 4px"
          height="20px"
          arrowColor="#000"
          position="bottom"
          marginLeft="45px"
          content={
            <div className="h-5 w-max flex items-center">
              <KSpan
                text={openSidebar ? lang.trends.hide_sidebar_and_filters : lang.trends.open_sidebar_and_filters}
                fontSize={12}
                lineHeight="16px"
                color="#FFF"
              />
            </div>
          }
        >
          <div className="flex items-center mt-1">
            <KButton
              dataTestId="daily-trends-side-bar"
              icon="/left-sidebar.svg"
              width="32px"
              height="32px"
              background="transparent"
              shadowDisabled={true}
              padding="4px"
              onClick={() => {
                if (setOpenSidebar) {
                  setOpenSidebar(!openSidebar)
                }
                setLoading(true)
                setTimeout(() => {
                  setLoading(false)
                }, 250)
              }}
            />
          </div>
        </KTooltip>
        <div className="pt-1 items-center">
          <KTitleSpan text={title} color="#111" fontSize={20} lineHeight="28px" />
        </div>
      </div>
    )
  }

  const findSelectedValue = (_key: string, options: KSelectOption[]) => {
    return options.filter((option) => filter[_key].includes(option.value2))
  }

  const onSearchTextChanged = async (text: string) => {
    if (!text) return
    setUserOptions([])
    clearTimeout(userTimeoutId)
    setUserTimeoutId(
      setTimeout(async () => {
        await handleAuthorizedRequest(async () => {
          const response = await users(`/?limit=10&offset=0&username=${text}`, "get")
          setUserOptions(
            response.data.results.map((optionUser: User) => ({
              value: optionUser.id,
              label: optionUser.username
            }))
          )
        }, "")
      }, 500)
    )
  }

  const multipleDropdownComponent = (
    title: string,
    options: KSelectOption[],
    _key: string,
    showOnlyIconsInMulti: boolean,
    width: number,
    sortSelectedFirst: boolean,
    reFetchOptions: boolean,
    dataTestId?: string
  ) => {
    return (
      <div>
        <div className="mb-1">
          <KSpan text={title} />
        </div>
        <div data-testid={dataTestId}>
          <KDropdown
            isClearable={true}
            isMulti={true}
            showOnlyIconsInMulti={showOnlyIconsInMulti}
            width={width}
            closeMenuOnSelect={false}
            options={options}
            onSelect={() => {}}
            onBlur={(selected) => {
              if (reFetchOptions) {
                setFetchOptions(true)
              }
              const value2List = (selected as KSelectOption[])?.map((entity) => entity.value2 || "") || []
              setFilter((prevFilter) => {
                if (value2List?.toString() === prevFilter[_key]?.toString()) {
                  return prevFilter
                }
                return { ...prevFilter, [_key]: value2List }
              })
              if (_key === "platformList") {
                setSelectedPlatforms(selected as KSelectOption[])
              }
            }}
            placeholder={lang.trends.filter.all}
            selected={_key === "platformList" ? selectedPlatforms : findSelectedValue(_key, options)}
            sortSelectedFirst={sortSelectedFirst}
          />
        </div>
      </div>
    )
  }

  const stringfyDateValue = (date?: Date) => {
    if (!date) {
      return
    }

    const month = lang.common.months_short[date.getMonth().toString()]
    return `${date.getDate()} ${month}`
  }

  const resetFilters = (eventType?: string) => {
    // all filters except selectedUsers and dateValues and eventType will be reset
    if (eventType) {
      setFilter({
        ...filter,
        ageGroupList: [],
        isrcList: [],
        artistList: [],
        sexList: [],
        countryList: [],
        platformList: [],
        eventType
      })
      return
    }
    setFilter({
      ...filter,
      ageGroupList: [],
      isrcList: [],
      artistList: [],
      sexList: [],
      countryList: [],
      platformList: []
    })
  }

  const renderFilters = () => {
    if (selectedTab === undefined) {
      return (
        <div>
          <KSpan text="Select to view" />
        </div>
      )
    }

    if (selectedTab === TabOptions.ROYALTY_THREE_MONTHS || selectedTab === TabOptions.STREAMS_TRACK_MONTHS) {
      return <div className="mb-4 flex"></div>
    }

    const platformSelection = multipleDropdownComponent(
      lang.trends.filter.platforms,
      platformOptions,
      "platformList",
      true,
      175,
      false,
      true,
      "platform-dropdown"
    )

    if (selectedTab === TabOptions.STREAMS_TRACK_MONTHS) {
      return (
        <div className="mb-4 flex">
          <div>{platformSelection}</div>
        </div>
      )
    }
    if (selectedTab === TabOptions.STREAMS_TOP_TRACKS) {
      return (
        <div className="flex gap-4">
          <div>{platformSelection}</div>
          <div className="mb-10">
            <div className="mb-1">
              <KSpan text={"Date"} />
            </div>
            <div>
              <div className="flex gap-2 mb-4 flex-wrap">
                <KInput
                  onChange={(text) => setDate(text)}
                  placeholder="Ex: 20250322"
                  value={date}
                  onBlur={(value) => {
                    if (value.length !== 8) {
                      toast.error("Wrong date format. Example: 20250322", errorFilledToastOptions)
                      return
                    }
                    fetchTrendTopTracks(value, true, filter).then(() =>
                      toast.success(`Success Date: ${date}`, successFilledToastOptions)
                    )
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )
    }

    const artistSelection = multipleDropdownComponent(
      lang.trends.filter.artists,
      artistOptions,
      "artistList",
      false,
      250,
      false,
      true,
      "artist-dropdown"
    )
    const songSelection = multipleDropdownComponent(
      lang.trends.filter.songs,
      songOptions,
      "isrcList",
      false,
      250,
      false,
      false,
      "song-dropdown"
    )
    const countrySelection = multipleDropdownComponent(
      lang.trends.filter.countries,
      countryOptions,
      "countryList",
      true,
      250,
      true,
      false,
      "country-dropdown"
    )
    const sexSelection = multipleDropdownComponent(
      lang.trends.filter.sex,
      sexOptions,
      "sexList",
      false,
      250,
      false,
      false,
      "sex-dropdown"
    )
    const ageGroupSelection = multipleDropdownComponent(
      lang.trends.filter.age_group,
      ageGroupOptions,
      "ageGroupList",
      false,
      250,
      false,
      false,
      "agegroup-dropdown"
    )

    return (
      <div className="mb-10 flex justify-between">
        <div>
          <div className="flex gap-2 mb-4 flex-wrap">
            <div>
              <div className="mb-1">
                <KSpan text={lang.trends.filter.category} />
              </div>
              <KDropdown
                width={140}
                rightIcon="/analytics_icons/caret-down-new.svg"
                enableIndicator={true}
                options={eventTypeOptions}
                onSelect={(selected) => {
                  setFetchOptions(true)
                  setTimeout(() => {
                    resetFilters((selected as KSelectOption)?.value2 || TREND_TRACK_EVENT_TYPE.DSP)
                    setFullScreenChartIndex(undefined)
                  }, 100)
                }}
                selected={eventTypeOptions.find((option) => option.value2 === filter.eventType)}
              />
            </div>
            <div>{platformSelection}</div>
            <div>{artistSelection}</div>
            <div>{songSelection}</div>
          </div>
          <div>
            {selectedTab === TabOptions.STREAMS_COUNTRY && <div>{countrySelection}</div>}
            {selectedTab === TabOptions.STREAMS_DEMOGRAPHIC && (
              <div className="flex gap-2 flex-wrap">
                <div>{countrySelection}</div>
                <div>{sexSelection}</div>
                <div>{ageGroupSelection}</div>
              </div>
            )}
          </div>
          {filter.eventType === "social" && (
            <div>
              <div className="mb-1 mt-4">
                <KSpan text={lang.trends.filter.social_data_type} />
              </div>
              <div>
                <KDropdown
                  width={220}
                  rightIcon="/analytics_icons/caret-down-new.svg"
                  enableIndicator={true}
                  options={socialTypeOptions}
                  onSelect={(selected) => {
                    setSelectedSocialType((selected as KSelectOption)?.value2 || "")
                  }}
                  selected={socialTypeOptions.find((option) => option.value2 === selectedSocialType)}
                />
              </div>
            </div>
          )}
        </div>
        <div>
          {!commonDateValues && (
            <div className="flex flex-row gap-2 items-center mt-5">
              <div className="p-3.5 bg-[#F7F7F7] rounded-[10px] gap-1 h-12 flex items-center">
                <KSpan text={stringfyDateValue(filter.dateValues?.[0]) || ""} color="#000" fontWeight={500} />
                <KSpan text={`-`} color="#000" fontWeight={500} />
                <KSpan text={stringfyDateValue(filter.dateValues?.[1]) || ""} color="#000" fontWeight={500} />
              </div>
              <div data-testid="date-range-wrapper">
                <KSelectRangeDate
                  value={filter.dateValues}
                  onChange={(event) => {
                    if (!event) {
                      return
                    }
                    if (event[1] - event[0] > MILISECONDS_MONTH) {
                      toast.error(lang.trends.error_month_range_limit, errorFilledToastOptions)
                      return
                    }

                    setFetchOptions(true)
                    setTimeout(() => {
                      if (filter.dateValues !== event) {
                        setFilter((prevFilter) => ({ ...prevFilter, dateValues: event }))
                      }
                    }, 100)
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  const selectTab = (tab: number) => {
    // only for daily, country and demographic tabs
    if (selectedTab !== tab) setFetchOptions(true)
    setTimeout(() => {
      setSelectedTab(tab)
      resetFilters()
      setFullScreenChartIndex(undefined)
    }, 100)
  }

  useEffect(() => {
    if (!externalTab) return
    if (externalTab === ANALYSIS_TAB_OPTIONS.TRENDS_DAILY) selectTab(TabOptions.STREAMS_DAILY)
    else if (externalTab === ANALYSIS_TAB_OPTIONS.TRENDS_COUNTRY) selectTab(TabOptions.STREAMS_COUNTRY)
    if (externalTab === ANALYSIS_TAB_OPTIONS.TRENDS_DEMOGRAPHIC) selectTab(TabOptions.STREAMS_DEMOGRAPHIC)
  }, [externalTab])

  const { start, end } = useMemo(() => {
    if (!Array.isArray(commonDateValues)) {
      return { start: undefined, end: undefined }
    }

    return {
      start: commonDateValues[0]?.getTime(),
      end: commonDateValues[1]?.getTime()
    }
  }, [commonDateValues])

  useEffect(() => {
    if (!Array.isArray(commonDateValues)) return

    setFilter((prev) => {
      if (!Array.isArray(prev.dateValues)) {
        return { ...prev, dateValues: commonDateValues }
      }

      const prevStart = prev.dateValues[0]?.getTime()
      const prevEnd = prev.dateValues[1]?.getTime()

      const nextStart = commonDateValues[0]?.getTime()
      const nextEnd = commonDateValues[1]?.getTime()

      if (prevStart === nextStart && prevEnd === nextEnd) {
        return prev
      }

      return {
        ...prev,
        dateValues: commonDateValues
      }
    })
  }, [start, end])

  return (
    <div className="flex bg-[#fff] h-screen">
      {!hideSideBarAndTitle && (
        <div
          className={`${
            openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
          } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0`}
          style={{
            transitionDuration: "0.5s"
          }}
        >
          <div className="pl-4 pr-3 py-4 whitespace-nowrap flex gap-2">
            <div style={{ textAlign: "left", display: "inline-block", cursor: "pointer" }} onClick={() => navigate(-1)}>
              <KLogo hoverEnabled={true} width={36} height={36} logoColor={"white"} borderRadius={1} />
            </div>
            <KTitleSpan text={lang.trends.title} lineHeight="28px" fontSize={20} color="#111" />
          </div>

          <div>
            <div className="py-1.5 px-4">
              <div
                data-testid="streams-daily"
                className={`rounded-[10px] p-2 flex flex-row gap-2 mt-4 items-center ${
                  selectedTab === TabOptions.STREAMS_DAILY ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap`}
                onClick={() => {
                  /*if (selectedTab !== TabOptions.STREAMS_DAILY) setFetchOptions(true)
                setTimeout(() => {
                  setSelectedTab(TabOptions.STREAMS_DAILY)
                  resetFilters()
                  setFullScreenChartIndex(undefined)
                }, 100)*/
                  selectTab(TabOptions.STREAMS_DAILY)
                }}
              >
                <img src={SparkleIcon} width={20} height={20} className="shrink-0" />
                <KSpan text={lang.trends.streams_daily} fontSize={14} lineHeight="16px" fontWeight={500} color="#111" />
              </div>
              <div
                data-testid="streams-country"
                className={`rounded-[10px] p-2 flex flex-row gap-2 mt-1 items-center ${
                  selectedTab === TabOptions.STREAMS_COUNTRY ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap`}
                onClick={() => {
                  /*if (selectedTab !== TabOptions.STREAMS_COUNTRY) setFetchOptions(true)
                setTimeout(() => {
                  setSelectedTab(TabOptions.STREAMS_COUNTRY)
                  resetFilters()
                  setFullScreenChartIndex(undefined)
                }, 100)*/
                  selectTab(TabOptions.STREAMS_COUNTRY)
                }}
              >
                <img src={WorldIcon} width={20} height={20} className="shrink-0" />
                <KSpan
                  text={lang.trends.streams_country}
                  fontSize={14}
                  lineHeight="16px"
                  fontWeight={500}
                  color="#111"
                />
              </div>
              <div
                data-testid="streams-demographic"
                className={`rounded-[10px] p-2 flex flex-row gap-2 mt-1 ${
                  selectedTab === TabOptions.STREAMS_DEMOGRAPHIC ? "bg-[#FFF]" : "transparent"
                } cursor-pointer whitespace-nowrap items-center`}
                onClick={() => {
                  /*if (selectedTab !== TabOptions.STREAMS_DEMOGRAPHIC) setFetchOptions(true)
                setTimeout(() => {
                  setSelectedTab(TabOptions.STREAMS_DEMOGRAPHIC)
                  resetFilters()
                  setFullScreenChartIndex(undefined)
                }, 100)*/
                  selectTab(TabOptions.STREAMS_DEMOGRAPHIC)
                }}
              >
                <img src={DemographicIcon} width={20} height={20} className="shrink-0" />
                <KSpan
                  text={lang.trends.streams_demographic}
                  fontSize={14}
                  lineHeight="16px"
                  fontWeight={500}
                  color="#111"
                />
              </div>
              {isAdmin && checkAdminPermission(ADMIN_PERMISSIONS.DAILY_TRENDS_TOP_100, user?.adminPermissions) && (
                <div
                  data-testid="streams-top-tracks"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-5 ${
                    selectedTab === TabOptions.STREAMS_TOP_TRACKS ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap items-center`}
                  style={{ borderTop: "1px dashed grey" }}
                  onClick={() => {
                    resetFilters()
                    setSelectedTab(TabOptions.STREAMS_TOP_TRACKS)
                  }}
                >
                  <img src={BarChartIcon} width={20} height={20} className="shrink-0" />
                  <KSpan text={"Top 100"} fontSize={14} lineHeight="16px" fontWeight={500} color="#111" />
                </div>
              )}
              {isAdmin && checkAdminPermission(ADMIN_PERMISSIONS.DAILY_TRENDS_STREAMS_L3M, user?.adminPermissions) && (
                <div
                  data-testid="streams-track-months"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-1 ${
                    selectedTab === TabOptions.STREAMS_TRACK_MONTHS ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap items-center`}
                  onClick={() => {
                    resetFilters()
                    setSelectedTab(TabOptions.STREAMS_TRACK_MONTHS)
                  }}
                >
                  <img src={BarChartIcon} width={20} height={20} className="shrink-0" />
                  <KSpan
                    text={"Streams Last 12 Months"}
                    fontSize={14}
                    lineHeight="16px"
                    fontWeight={500}
                    color="#111"
                  />
                </div>
              )}
              {isAdmin && checkAdminPermission(ADMIN_PERMISSIONS.DAILY_TRENDS_ROYALTY_L3M, user?.adminPermissions) && (
                <div
                  data-testid="royalty-three-months"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-1 ${
                    selectedTab === TabOptions.ROYALTY_THREE_MONTHS ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap items-center`}
                  onClick={() => {
                    resetFilters()
                    setSelectedTab(TabOptions.ROYALTY_THREE_MONTHS)
                  }}
                >
                  <img src={MoneyIcon} width={20} height={20} className="shrink-0" />
                  <KSpan
                    text={"Royalty Last 12 Months"}
                    fontSize={14}
                    lineHeight="16px"
                    fontWeight={500}
                    color="#111"
                  />
                </div>
              )}
            </div>

            {isAdmin && (
              <div className="mt-2 py-1.5 px-4">
                <KDropdown
                  dataTestId="trends-search-user"
                  isMulti={true}
                  placeholder={"Search user to filter"}
                  closeMenuOnSelect={false}
                  selected={selectedUsers}
                  disableFilterOption={true}
                  onInputChange={onSearchTextChanged}
                  options={userOptions}
                  isClearable={true}
                  onBlur={() => {
                    setSelectedResults([])
                    setOffset(0)
                    setFetchOptions(true)
                    const userIds = selectedUsers.map((selectedUser) => selectedUser.value)
                    setTimeout(() => {
                      setFilter((prevFilter) => ({ ...prevFilter, selectedUsers: userIds }))
                    }, 100)
                  }}
                  onSelect={(selectedOption) => {
                    if (!selectedOption) {
                      setSelectedUsers([])
                      return
                    }
                    setSelectedUsers(selectedOption as KSelectOption[])
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
      <div className="grow flex justify-center overflow-x-auto p-3 h-screen min-h-0">
        <div
          className="w-full flex flex-col items-center h-full"
          style={{
            paddingRight: hideSideBarAndTitle ? 0 : 40,
            paddingLeft: hideSideBarAndTitle ? 0 : 20
          }}
        >
          {!hideSideBarAndTitle && renderTableTitle()}
          <div className="pt-5 w-full flex-1 min-h-0 flex flex-col">
            {openSidebar && renderFilters()}
            {loading && <Loading />}
            {!loading && selectedTab === TabOptions.STREAMS_DAILY && (
              <StreamsDaily
                streamsDaily={streamsDaily}
                fullScreenChartIndex={fullScreenChartIndex}
                setFullScreenChartIndex={setFullScreenChartIndex}
                eventType={normalizedEvent}
              />
            )}
            {!loading && selectedTab === TabOptions.STREAMS_COUNTRY && (
              <StreamsCountry
                streamsCountry={streamsCountry}
                fullScreenChartIndex={fullScreenChartIndex}
                setFullScreenChartIndex={setFullScreenChartIndex}
                eventType={normalizedEvent}
              />
            )}
            {!loading && selectedTab === TabOptions.STREAMS_DEMOGRAPHIC && (
              <StreamsDemographic
                streamsDemographic={streamsDemographic}
                fullScreenChartIndex={fullScreenChartIndex}
                setFullScreenChartIndex={setFullScreenChartIndex}
                eventType={normalizedEvent}
              />
            )}
            {!loading && selectedTab === TabOptions.STREAMS_TOP_TRACKS && (
              <StreamsTopTracks trendTopTracks={trendTopTracks} />
            )}
            {!loading && selectedTab === TabOptions.STREAMS_TRACK_MONTHS && (
              <StreamsTrackMonths
                artistTrendEconomyData={artistTrendEconomyData}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                selectedRoyaltyType={selectedRoyaltyType}
                setSelectedRoyaltyType={setSelectedRoyaltyType}
                selectedResults={selectedResults}
                setSelectedResults={setSelectedResults}
                hasNext={hasNext}
              />
            )}
            {!loading && selectedTab === TabOptions.ROYALTY_THREE_MONTHS && (
              <RoyaltyThreeMonths
                artistTrendEconomyData={artistTrendEconomyData}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                selectedRoyaltyType={selectedRoyaltyType}
                setSelectedRoyaltyType={setSelectedRoyaltyType}
                selectedResults={selectedResults}
                setSelectedResults={setSelectedResults}
                hasNext={hasNext}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    options: state.trends.options,
    streamsDaily: state.trends.streamsDaily,
    streamsCountry: state.trends.streamsCountry,
    streamsDemographic: state.trends.streamsDemographic,
    trendTopTracks: state.trends.trendTopTracks,
    streamsTrackMonths: state.trends.streamsTrackMonths,
    artistTrendEconomyData: state.trends.artistTrendEconomyData,
    user: state.auth.user
  }
}

export default connect(mapStateToProps, {
  fetchStreamsDaily,
  fetchStreamsCountry,
  fetchStreamsDemographic,
  fetchTrendTopTracks,
  fetchStreamsTrackMonths,
  fetchArtistTrendEconomyData
})(Trends)
